import { render, staticRenderFns } from "./ValueSection.vue?vue&type=template&id=5006df9b&scoped=true&"
import script from "./ValueSection.vue?vue&type=script&lang=js&"
export * from "./ValueSection.vue?vue&type=script&lang=js&"
import style0 from "./ValueSection.vue?vue&type=style&index=0&id=5006df9b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006df9b",
  null
  
)

export default component.exports